import { GradientMesh, PageTransition } from '@merritrac/shared/components';
import { Outlet, useLocation } from 'react-router';

import { usePortalAuth } from '../../hooks/usePortalAuth.js';

import { PortalHeader } from './PortalHeader.js';

import type { ReactElement } from 'react';

export function PortalLayout(): ReactElement {
  const { user, logout } = usePortalAuth();
  const location = useLocation();

  const headerUser = {
    name: user?.username ?? '',
    clientName: user?.clientName ?? '',
  };

  return (
    <div className="min-h-screen relative">
      <GradientMesh />
      <PortalHeader user={headerUser} onLogout={logout} />
      <main className="pt-[var(--header-h)] relative z-10">
        <div className="max-w-6xl mx-auto px-6 py-8">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </div>
      </main>
    </div>
  );
}
